import * as ko from 'knockout';
import { Enumerable } from '../../shared/linq';
import type { IGame } from '../../shared/interfaces/IGame';
import type { IWeek } from '../../shared/interfaces/IWeek';
import type { ITeam } from '../../shared/interfaces/ITeam';
import type { ISeries } from '../../shared/interfaces/ISeries';

export class CfbWeek implements IWeek {
  Division: KnockoutObservable<string>;
  games: KnockoutObservableArray<KnockoutObservable<IGame>>;
  GamesComputed: KnockoutComputed<any>;
  TeamsInWeek: KnockoutObservableArray<number>;
  // IWeek stubs — CFB does not use ranked or bye-week computed properties
  RankComputed: KnockoutComputed<KnockoutObservable<ITeam>[]>;
  TeamsOnBye: KnockoutComputed<KnockoutObservable<ITeam>[]>;
  Series: KnockoutObservableArray<ISeries>;

  constructor(Division: string) {
    const self = this;
    self.TeamsInWeek = ko.observableArray([]);
    self.Division = ko.observable<string>(Division);
    self.games = ko.observableArray<KnockoutObservable<IGame>>();
    self.RankComputed = ko.computed((): KnockoutObservable<ITeam>[] => []);
    self.TeamsOnBye = ko.computed((): KnockoutObservable<ITeam>[] => []);
    self.Series = ko.observableArray([]);

    self.GamesComputed = ko.computed(() =>
      Enumerable.From(self.games())
        .OrderBy((p: any) => {
          if (typeof p === 'function') return p().SortOrder();
          return p.SortOrder();
        })
        .ThenBy((p: any) => {
          if (typeof p === 'function') return p().home().TeamAbbreviation;
          return p.home().TeamAbbreviation;
        })
        .ToArray(),
    );

    self.games.subscribe((newVal) => {
      const game: any = ko.unwrap(newVal[0].value);
      const home = ko.unwrap(game.home);
      const away = ko.unwrap(game.away);
      self.TeamsInWeek.push(home.TeamID);
      self.TeamsInWeek.push(away.TeamID);
    }, null, 'arrayChange');
  }
}
